export const HOME_H2_CLASS =
  'text-[18px] leading-[24px] font-normal text-gray-700 dark:text-white md:text-[20px] md:leading-[26px] md:font-normal';
